export const paymentOptions:any = [
    { value: "Free", label: "Free" },
    { value: " Cash (USD)", label: " Cash (USD)" },
    { value: "Credit or Debit Card", label: "Credit or Debit Card" },    
    { value: "Mobile Pay Options", label: "Mobile Pay Options" },    
]